import React from 'react';
import { useTheme } from './ThemeProvider';
import { Sun, Moon, Monitor } from 'lucide-react';

export function ThemeSwitcher() {
  const { currentTheme, setTheme, themes } = useTheme();

  return (
    <div className="flex items-center gap-2 rounded-lg bg-muted p-1">
      <button
        onClick={() => setTheme(themes.LIGHT)}
        className={`inline-flex items-center justify-center rounded-md p-2 text-sm font-medium transition-colors hover:bg-background hover:text-foreground ${
          currentTheme === themes.LIGHT ? 'bg-background text-foreground' : 'text-muted-foreground'
        }`}
        title="Light mode"
      >
        <Sun className="h-4 w-4" />
        <span className="sr-only">Light mode</span>
      </button>
      <button
        onClick={() => setTheme(themes.DARK)}
        className={`inline-flex items-center justify-center rounded-md p-2 text-sm font-medium transition-colors hover:bg-background hover:text-foreground ${
          currentTheme === themes.DARK ? 'bg-background text-foreground' : 'text-muted-foreground'
        }`}
        title="Dark mode"
      >
        <Moon className="h-4 w-4" />
        <span className="sr-only">Dark mode</span>
      </button>
      <button
        onClick={() => setTheme(themes.SYSTEM)}
        className={`inline-flex items-center justify-center rounded-md p-2 text-sm font-medium transition-colors hover:bg-background hover:text-foreground ${
          currentTheme === themes.SYSTEM ? 'bg-background text-foreground' : 'text-muted-foreground'
        }`}
        title="System theme"
      >
        <Monitor className="h-4 w-4" />
        <span className="sr-only">System theme</span>
      </button>
    </div>
  );
} 